import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function NuevoParametroEvolucion() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    
    const [nombre, setNombre] = useState('');
    const [tipoCampo, setTipoCampo] = useState('textarea');

    let history = useHistory();

    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        /*if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }*/

        const conf = {
            /*headers: { Authorization: 'Bearer ' + userdata.access_token },*/
            client_id: client.client_id,
            nombre: nombre,
            tipo_campo: tipoCampo
        };
        
        axios.post('/parametro-evolucion', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg', 'El Parámetro "'+nombre+'" Ha Sido Creado');
                    history.push('/parametros-evolucion');
                }
            )
            .catch(
                err => {
                    console.log(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-plantillas">Administrar Plantillas</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/parametros-evolucion">Parámetros en Evolución</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Nuevo Parámetro en Evolución</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Nuevo Parámetro De Evolución</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-12">
                                
                            <form id="role-form" onSubmit={handleSubmit}>
                                <div className="card">
                                    <div id="infobasica">
                                        <div className="card-body">

                                            
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="nombre">Nombre</label>
                                                        <input type="text" name="nombre" className="form-control" id="nombre" onChange={(e) => setNombre(e.target.value)} required />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="tipo_campo">Tipo de Campo</label>
                                                        <select name="tipo_campo" id="tipo_campo" className="form-control" value={tipoCampo} onChange={(e) => setTipoCampo(e.target.value)}>
                                                            <option value="textarea">Área de Texto</option>
                                                            <option value="text">Campo de Texto</option>
                                                            <option value="checkbox">Campo de Verificación</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{marginTop: '30px'}}>
                                    <div className="col-md-6">
                                        <Link to="/parametros-evolucion" className="btn btn-secondary" style={{marginRight: '10px'}}>
                                            Cancelar
                                        </Link>
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            Crear Parámetro de Evolución&nbsp;
                                            {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                            
                                        </button>
                                    </div>
                                </div>
                            </form>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default NuevoParametroEvolucion;